import React from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { parseDateToTz } from '../utils/GlobalFunctions';

import { TableRow, TableCell } from '../ui/table';
import { Button } from '../ui/button';

const ReportRow = ({ reportDetails, currentOrganisation }) => {
  const { startDate, endDate } = reportDetails || {};

  return (
    <TableRow className='hover:bg-muted/50 text-base'>
      <TableCell className='font-medium text-left'>{reportDetails.name}</TableCell>
      <TableCell>
        {startDate && endDate
          ? `${format(parseDateToTz(startDate, 'yyyy-MM-dd'), 'dd/MM/yyyy')} -
            ${format(parseDateToTz(endDate, 'yyyy-MM-dd'), 'dd/MM/yyyy')}`
          : 'N/A'}
      </TableCell>
      <TableCell>{reportDetails.status}</TableCell>
      <TableCell className='text-center'>
        <Button className='h-8 p-2 bg-secondary text-secondary-foreground hover:text-primary-foreground' asChild>
          <Link to={`/report/${currentOrganisation}/${reportDetails.id}`}>View</Link>
        </Button>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state) => {
  return {
    currentOrganisation: state.currentOrganisation,
  };
};

export default connect(mapStateToProps)(ReportRow);
